import * as React from 'react';
import { Editor, useCurrentEditor } from '@tiptap/react';

export function useTiptapEditor(providedEditor?: Editor | null): { editor: Editor | null } {
  const { editor: coreEditor } = useCurrentEditor();
  const editor = React.useMemo(() => providedEditor || coreEditor, [providedEditor, coreEditor]);
  return { editor };
}
